// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1mE81","upload":"Small_upload__1pdTw","imageWrap":"Small_imageWrap__1f5_u","removeBtn":"Small_removeBtn__2ynX5"};